// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/plugins/variablesWindow' // importante que esté al principio
import Vue from 'vue'
import VueTrumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
// Plugins trumbowyg
import 'trumbowyg/dist/plugins/pasteembed/trumbowyg.pasteembed.js'
import 'trumbowyg/dist/plugins/cleanpaste/trumbowyg.cleanpaste.js'
import 'trumbowyg/dist/langs/es.js'
import { store } from './store/store'
import router from './router'
import '@/plugins/entorno' // importante que esté antes que vuetify e i18n
import i18n from '@/plugins/vue-i18n'
import { BASE_URL } from '@/api/api'
import '@/plugins/vuetify'
import '@/plugins/styles' // importante que esté despues de vuetify
import '@/plugins/components'
import '@/plugins/directives'
import '@/plugins/filters'
import '@/plugins/mixins'

import App from './App'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    $downloadCondiciones (id, texto) {
      if (texto) {
        return BASE_URL + 'documentacion/download_pdf_condiciones' + encodeURI(`?jsondata={"parametros":{"id_reserva":" ${id} ","texto":${texto}}}`)
      } else {
        return '' // TODO DEVOLVER PLACEHOLDER
      }
    }
  }
})

Vue.use(VueTrumbowyg)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js